import { EventEmitter } from 'events';

import dispatcher from '../others/Dispatcher';
import * as DH from '../others/DataHelpers';

class QuickWinStore extends EventEmitter {
    constructor() {
        super()
        this.columns = [
            { id: 'status', numeric: false, disablePadding: false, label: '', sort: true },
            { id: 'number', numeric: false, disablePadding: false, label: '#', sort: true },
            { id: 'title', numeric: false, disablePadding: false, label: 'Title' },
            // { id: 'summary', numeric: false, disablePadding: false, label: 'Summary' },
            { id: 'severity', numeric: false, disablePadding: false, label: 'SEV', sort: true },
            { id: 'assignment', numeric: false, disablePadding: false, label: 'Assignment', sort: true },
            { id: 'release', numeric: false, disablePadding: false, label: 'Release', sort: true },
            { id: 'created', numeric: false, disablePadding: false, label: 'Created', sort: true },
            { id: 'updated', numeric: false, disablePadding: false, label: 'Updated', sort: true },
        ];
        this.tickets = [];
        this.ticketsDisplay = [];
        this.filter = {
            status: 'OPEN',
            release: 'ANY',
            severity: 'ANY',
            assignment: 'ANY',
            updated: '30'
        };
        this.sort = {
            order: 'desc',
            orderBy: 'number',
            secondaryOrder: 'desc',
            secondaryOrderBy: 'number',
        };
        this.meta = {
            page: 0,
            rowsPerPage: 25,
            loading: true,
            refresh: false,
            authentication: true,
            username: null
        };
        const timeParameter = DH.getPastDate(this.filter.updated);
        this.github = {
            filter: {
                labels: 'quick-win',
                state: 'all',
                since: timeParameter
            },
            user: 'MindTouch',
            repo: 'Deki',
            type: 'tickets'
        }
    }

    getAll() {
        const { columns, tickets, ticketsDisplay, filter, gitFilter, sort, meta } = this;
        return {
            columns,
            tickets,
            ticketsDisplay,
            filter,
            gitFilter,
            sort,
            meta
        }
    }

    updateTickets = (location) => {
        let filter;

        if(location) {
            const params = DH.parseParams(location);
            filter = params.filter;
        } else {
            filter = this.filter;
        }

        if(filter.updated === this.filter.updated && this.tickets.length > 0) {
            this.updateFilter(filter);
        } else {
            this.github.filter.since = DH.getPastDate(filter.updated);
            const params = {
                filter: this.github.filter,
                user: this.github.user,
                repo: this.github.repo,
                type: this.github.type
            }
            DH.getTickets(params)
                .then(({username, tickets}) => {
                    this.meta.username = username;
                    this.tickets = tickets;
                    this.updateFilter(filter);
                })
                .catch((error) => {
                    this.tickets = [];
                    this.ticketsDisplay = [];
                    this.meta.loading = false;
                    this.meta.authentication = false;
                    this.emit('change');
                })
        }
    }


    updateFilter = (filter) => {
        this.filter = filter;
        this.ticketsDisplay = this.tickets
            .filter(DH.getStatusFiltering(this.filter))
            .filter(DH.getAssignmentFiltering(this.filter))
            .filter(DH.getReleaseFiltering(this.filter))
            .filter(DH.getSeverityFiltering(this.filter))
            .sort(DH.getSorting(this.sort));

        if(!(this.ticketsDisplay.length > 0)) {
            this.ticketsDisplay = [{id: 'NA', status: { sort: -1 }}]
        }
        this.meta.loading = false;
        this.emit('change');
    }

    updateSort = (sortEvent) => {
        if(this.sort.orderBy === sortEvent.property) {
            this.sort.order = (this.sort.order === 'asc') 
                ? 'desc' 
                : 'asc';
        } else {
            this.sort.order = 'desc';
        }
        this.sort.orderBy = sortEvent.property;

        const newTicketsDisplay = this.ticketsDisplay
            .sort(DH.getSorting(this.sort));
        this.ticketsDisplay = newTicketsDisplay;
        this.meta.loading = false;
        this.emit('change');
    }

    updateMeta = (meta) => {
        this.meta = meta;
        this.emit('change');
    }

    updateAuthentication = (authentication) => {
        this.meta.authentication = authentication;
        this.emit('change');
    }

    handleActions = (action) => {
        switch(action.type) {
            case 'UPDATE_QUICKWIN_TICKETS':
                this.updateTickets(action.body);
                break;
            case 'UPDATE_QUICKWIN_TICKETS_ADVANCED_DISPLAY':
                this.updateTicketsAdvancedDisplay(action.body);
                break;
            case 'UPDATE_QUICKWIN_FILTER':
                this.updateFilter(action.body);
                break;
            case 'UPDATE_QUICKWIN_SORT':
                this.updateSort(action.body);
                break;
            case 'UPDATE_QUICKWIN_META':
                this.updateMeta(action.body);
                break;
            case 'REFRESH':
                this.updateTickets(action.body);
                break;
            case 'UPDATE_AUTHENTICATION':
                this.updateAuthentication(action.body);
                break;
            default:
        }
    }
}

const quickWinStore = new QuickWinStore();
dispatcher.register(quickWinStore.handleActions.bind(quickWinStore));
window.customerAStore = quickWinStore;
export default quickWinStore;


// WEBPACK FOOTER //
// ./src/js/stores/QuickWinStore.js